export interface ImageSources {
    mobile: {
        regular?: string;
        retina?: string;
    };
    desktop: {
        regular?: string;
        retina?: string;
    };
}

export function makeSrcSet(image1?: string, image2x?: string, image3x?: string): string | undefined {
    const imageParts = [];

    if (image1) {
        imageParts.push(`${image1} 1x`);
    }

    if (image2x) {
        imageParts.push(`${image2x} 2x`);
    }

    if (image3x) {
        imageParts.push(`${image3x} 3x`);
    }

    if (imageParts.length > 0) {
        return imageParts.join(', ');
    }

    return undefined;
}
